import { getTeamUrl } from 'Common'
import getParams from '../../../Utils/getParams'

export default (isHolidayExport = false) => (dispatch, getState) => {

  const state = getState()

  const { controls } = state.screens.Planner

  const params = getParams(controls)

  let url = `planner/export?`

  // Add holiday export parameter if this is a holiday export
  if (isHolidayExport) {
    url += `&holiday_export=1`
  }

  Object.keys(params).forEach(key => {
    if (params[key] !== undefined) url += `&${key}=${params[key]}`
  })

  window.location = getTeamUrl(url, 'exports')

}
